'use client';

import { ComponentPropsWithRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { Button } from '.';

interface Props {
  children: React.ReactNode;
  selected?: boolean;
  className?: string;
  onClick: () => void;
}

export default function PropertiesViewButton({
  children,
  selected,
  className = '',
  onClick,
  ...otherProps
}: Props): React.ReactElement {
  return (
    <Button
      className={twMerge(
        'properties-view-button group',
        className,
        selected && 'text-gray-700 bg-white',
        !selected && 'text-gray-600 bg-gray-100'
      )}
      type="button"
      onClick={onClick}
      {...otherProps}
    >
      {children}
    </Button>
  );
}
